/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Link, useNavigate} from 'react-router-dom'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../../setup'
// import {Languages} from './Languages'
import {getInitials, logoutPopup} from '../../../../app/services/Functional'

const HeaderUserMenu: FC = () => {
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  const navigate = useNavigate()
  const logout = () => {
    logoutPopup(navigate)
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            {user.avatar ? (
              <img alt='Logo' src={`${process.env.REACT_APP_AWS_URL}${user.avatar}`} />
            ) : (
              <div className='symbol-label fs-3 bg-light-primary text-primary'>
                {getInitials(user.name)}
              </div>
            )}
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{user.name}</div>
            <a href='#' className='fw-bold text-muted cursor-default fs-7 mb-1'>
              {user.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2' />

      <div className='menu-item px-5'>
        <Link to={'/profile/update'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      <div className='menu-item px-5'>
        <Link to={'/profile/change-password'} className='menu-link px-5'>
          Change Password
        </Link>
      </div>

      {/*<Languages />*/}

      <div className='separator my-2' />

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Logout
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
